import { equals2, find, isNil } from "fxjs/es";
export const translateEl = (self, { id, tx, ty }) => {
  const translate_transform = self._getTranslateTransformThrowable();
  const el = find((el) => equals2(el.id)(id))(self.getEls());
  if (isNil(el)) {
    throw new Error(`id(${id}) 에 해당하는 엘리먼트를 찾을 수 없습니다.`);
  }
  translate_transform.translate({
    el: el.wrapper_el,
    f: ({ svg_el }) => {
      const transform = svg_el.createSVGTransform();
      transform.setTranslate(tx ?? 0, ty ?? 0);
      return transform.matrix;
    },
  });
};
